import { z } from 'zod';
import { pageQuerySchema } from '#src/common/pagination.contract.js';
/** Limites de segurança: o filtro é texto livre vindo da URL. */
export const MAX_FILTER_LENGTH = 2000;
export const MAX_SEARCH_TEXT_LENGTH = 100;
const MAX_SORT_LENGTH = 200;
/** `campo` ou `-campo` (decrescente), separados por vírgula. */
const SORT_PATTERN = /^-?[A-Za-z][\w.]*(,-?[A-Za-z][\w.]*)*$/;
/**
 * Query string de toda rota de busca (ver docs/development/api-conventions.md):
 *
 * - `q`: texto livre, procurado nos campos de texto principais do recurso.
 *   Com várias palavras, cada uma precisa aparecer em algum desses campos.
 * - `filter`: RSQL, só com os campos que o recurso libera
 *   (`active==true;name==*silva*`).
 * - `sort`: campos separados por vírgula, `-` para decrescente
 *   (`-createdAt,name`).
 * - `page` e `pageSize`.
 *
 * Texto vazio vale como ausente.
 */
export const searchQuerySchema = pageQuerySchema.extend({
    q: z.string().trim().max(MAX_SEARCH_TEXT_LENGTH).optional(),
    filter: z.string().trim().max(MAX_FILTER_LENGTH).optional(),
    sort: z
        .string()
        .trim()
        .max(MAX_SORT_LENGTH)
        .regex(SORT_PATTERN, 'campos separados por vírgula, - para decrescente')
        .optional()
        .or(z.literal('')),
});
//# sourceMappingURL=search.contract.js.map